var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SettingsNavigation'),_c('BaseWrapper',[(_vm.canSwitchToPerCandidate && _vm.paygSubscription)?_c('BillingChoiceCard'):_vm._e(),(_vm.isPerCandidate)?_c('CandidateBillingCard'):_c('PAYGPlansCard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }